import React, { useState, useEffect } from 'react';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import appUrl from '../../../../constants/appUrl';

const AgainstProductComplaint = ({ product }) => {
    const [complaintList, setComplaintList] = useState([]);

    const getComplaintById = async (productId) => {
        try {
            const response = await fetch(`${appUrl.baseUrl}api/Complaint/GetComplaintByProductId/${productId}`);
            const data = await response.json();
            setComplaintList(data);
        } catch (error) {
            console.error('Error fetching complaints:', error);
        }
    };

    useEffect(() => {
        if (product && product.productId) {
            getComplaintById(product.productId);
        }
    }, [product]);

    return (
        <div className='grid'>
            <div className='md:col-12'>
                {complaintList.map(complaint  => (
                    <div className='card' key={complaint.complaintID}>
                        <p style={{ fontWeight: 'bold', margin: '0px' }}>{complaint.productName}</p>
                        <p style={{ margin: '0px' }}>{complaint.productCreatedDate}</p>

                        <DataTable
                            value={complaint.complaintResponse}
                            scrollable
                            scrollHeight="500px"
                            paginator
                            rows={5}
                        >
                            <Column field="complaintID" header="Complaint ID" style={{ minWidth: "6rem" }} />
                            <Column field="responseDetail" header="response Detail" />
                            <Column field="complaintPrefix" header="Complaint Prefix" />
                        </DataTable>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default AgainstProductComplaint;
